import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { BLOG_TAGS } from "./components/BlogNavigation";
import { useBlogContext } from "./context/BlogContext";
export const useGetTagFromUrl = () => {
    const [searchParams] = useSearchParams();
    const { setSelectedTag } = useBlogContext();
    useEffect(() => {
        const tagParam = searchParams.get("tag");
        if (!tagParam) {
            setSelectedTag("All");
            return;
        }
        const matched = BLOG_TAGS.find(t => t === tagParam);
        setSelectedTag(matched !== null && matched !== void 0 ? matched : "All");
    }, [searchParams]);
};
